<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

export default {
  name: "Dropdown",
  components: {
    FontAwesomeIcon,
  },
  props: {
    value: {
      type: [Object, null],
      required: false,
      default: null,
    },
    options: {
      type: Array,
      required: false,
      default: Array,
    },
    label: {
      type: String,
      required: false,
      default: "name",
    },
  },
  data: function () {
    return {
      selecting: false,
      selectedOption: null,
    };
  },
  methods: {
    setSelectedOption(selectedOption) {
      this.selectedOption = selectedOption;
      this.$emit("change", selectedOption);
      this.selecting = false;
    },
    fireOpenedEvent() {
      this.selecting = true;
      this.$emit("opened");
    },
  },
  mounted() {
    this.selectedOption = this.value;
  }
}
</script>

<template>
<div>
  <div class="container" v-if="!selecting">
    <div class="row booking-dropdown client-border p-2" @click="fireOpenedEvent">
      <div class="col-10 col-md-11">{{ selectedOption ? selectedOption[label] : '' }}</div>
      <div class="col-2 col-md-1"><FontAwesomeIcon :icon="['fas', 'chevron-down']" size="lg" /></div>
    </div>
  </div>
  <div class="container" v-if="selecting">
    <div class="row">
      <h6 class="ircc-blue">Select a value -</h6>
    </div>
    <div class="row">
      <div v-for="option in options" class="col-md-4" @click="setSelectedOption(option)">
        <div class="booking-dropdown-option mb-2 rounded p-3" :class="{
        'booking-dropdown-option-selected': selectedOption === option,
      }">
          {{ option[label] }}
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
.client-border {
  border: #2484C6 1px solid;
}

.booking-dropdown {
  border: #91c2e3 3px solid;
  border-radius: 24px;
  color: #91c2e3;
}
</style>